// extracted by mini-css-extract-plugin
module.exports = {"container":"GroupOrderUnSupportedNote_container__cjr0E"};